import EmailVerification from 'views/register/emailVerification/EmailVerification.container';

export default EmailVerification;